import { render, staticRenderFns } from "./ItemSkill.vue?vue&type=template&id=070aa716&scoped=true&lang=pug"
import script from "./ItemSkill.vue?vue&type=script&lang=ts"
export * from "./ItemSkill.vue?vue&type=script&lang=ts"
import style0 from "./ItemSkill.vue?vue&type=style&index=0&id=070aa716&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070aa716",
  null
  
)

export default component.exports